const dataset = document.getElementById("wizardQuestionnaireScript").dataset

$(document).ready(function () {
  $('#wizardapp').removeClass().addClass('col-xs-12 col-md-12 t-body-text')
  if ($("h1").length > 1 ) {
    $('#wizardTitleDiv').remove()
  }

  const url_string = window.location.href
  const paramUrl = new URL(url_string);
  const param = paramUrl.searchParams.get("path")

  $('form').submit(false)

  let url = window.location;
  url = url.toString()

  if (dataset.hasgoal && dataset.hasgoal === 'true' && dataset.goalname && param.indexOf(dataset.goalname) === -1) {
    history.pushState({}, null, `${url}-${dataset.goalname}`);
  }

  if (param != null) {
    $("#initVeiviser").remove()
    $("#startVeiviser").remove()
    $("#wizardapp").css("display", "block")
    changePageTitle()
    $("#beskrivelse_under_knapp").remove()
    $("#partRegion").remove()

    updateBreadcrumbs()
  } else {
    $("#initVeiviser").removeAttr("hidden")
    $("#startVeiviser").removeAttr("hidden")
    $("#beskrivelse_under_knapp").removeAttr("hidden")
    $("#partRegion").removeAttr("hidden")
  }
});

function updateBreadcrumbs() {
  const breadcrumbs = JSON.parse(dataset.breadcrumbs)
  breadcrumbs.pop()
  breadcrumbs.forEach((breadcrumb) => {
    $('.b-breadcrumbs').append(`<a href="${breadcrumb.link}" class="b-breadcrumbs__link">${breadcrumb.title}</a>`)
  })
}

$("#nextStep").on("click", function () {
  const answerSelected = $('input[name="answerSelectedInput"][type="radio"]:checked').val() || $('#answerSelectedSelect option:selected').val()

  if ( answerSelected !== undefined ) {
    let url = dataset.url

    if (url.indexOf('path=') === -1) {
      url = url.replace('?', '') + '?path=' + Number(answerSelected)
    } else if (url[url.length - 1] === '=') {
        url = url + '' + Number(answerSelected)
    } else {
      url = url + '-' + Number(answerSelected)
    }

    window.location.href = url
  }
})

$("#startVeiviser").on("click", function () {
  window.location.href = dataset.url + '?path=';
})

const len = $("article")
if (len.length > 2) {
  $("#startVeiviser").remove()
  $("#wizardapp").css("display", "block")
}

function changePageTitle() {
  const title = $('#wizardapp h1').text()

  if (title) {
    document.title = title + document.title.substring(document.title.lastIndexOf(' -'));
  }
}
